import {create_shoppingshow_url} from "../request/api.js";
//将mutations中内容应用到整个Application中
export const setLogin = ({commit}, userToken) => {
  commit('checkLogin', userToken)
};


export const setUserInfo = ({commit}, info) => {
  commit('userInfo', info)
};

//  获取购物车数量并更新
export const setCarCount = ({commit}, count) => {
  commit('carCount', count)
};


export const getCarCount = ({commit}) => {
  create_shoppingshow_url().then((res) => {
    commit('carCount', res.data.data.length)
  }).catch((error) => {
    console.log(error)
  });
  
};



// WEBPACK FOOTER //
// ./src/vuex/actions.js